import { analyticsService } from './analytics';

export const Services = {
    analytics: analyticsService()
}